import { gql } from "@apollo/client";

const GET_TEAM_DAILY_STANDUP_REPORT = gql`
  query GetTeamDailyReport($teamId: ID!, $filters: DailyReportFilter!) {
    teamDailyReport(teamId: $teamId, filters: $filters) {
      week
      year
      participantReports {
        date
        status
        completedAt
        user {
          name
          imageUrl
        }
        standupEntries {
          question
          answer
          category
          optional
        }
      }
    }
  }
`;

export { GET_TEAM_DAILY_STANDUP_REPORT };
